
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/domoreport-repair-estimates",
      function () {
        return require("private-next-pages/features/domoreport-repair-estimates.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/domoreport-repair-estimates"])
      });
    }
  